import React from "react"
import ReactHtmlParser from "react-html-parser";
import { makeStyles } from "@material-ui/core/styles"
import {
    Avatar, Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, IconButton, List, ListItem, ListItemAvatar,
    ListItemSecondaryAction, ListItemText, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography
} from "@material-ui/core"
import { Timeline, TimelineConnector, TimelineContent, TimelineDot, TimelineItem, TimelineOppositeContent, TimelineSeparator } from "@material-ui/lab"
import CloseIcon from '@material-ui/icons/Close'
import CancelPresentationIcon from '@material-ui/icons/CancelPresentation';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight'
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown'
import { red, blue, teal, purple, orange } from '@material-ui/core/colors'
import { DIYActions } from "../../../../actions"
import FileDropArea from '../../../../utils/FileDropArea'
import Icons from "../../../../assets/images/Icons"
import RSSITicketSteps from "./RSSITicketSteps"
import { ExpandedRow } from "../RSSITickets"

const useStyles = makeStyles((theme) => ({
    rootDesktop: { marginTop: theme.spacing(2), marginLeft: theme.spacing(10), marginRight: theme.spacing(10) },
    rootTablet: { marginTop: theme.spacing(2), marginLeft: theme.spacing(5), marginRight: theme.spacing(5) },
    rootMobile: { marginTop: theme.spacing(1), marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
    coloredpaper: { color: theme.palette.text.secondary, backgroundColor: "#303030" },
    commentCard: { marginLeft: theme.spacing(1), marginRight: theme.spacing(1) },
    tableRow: { display: "table-row", paddingTop: 5, paddingBottom: 5, "&:hover": { backgroundColor: theme.palette.background.secondary } },
    closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
    tablenoborder: { border: "2px solid #212121" },
}));


const CloseComment = ({ open, quantumId, workorder, onClose, onSubmit, deeplinked = false }) => {
    const classes = makeStyles((theme) => ({
        closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
    }))()
    const [comment, setComment] = React.useState("")

    const onCloseReset = () => {
        setComment("")
        onClose()
    }

    const onTicketSubmit = () => {
        onSubmit(comment)
        onCloseReset()
    }

    return (
        <Dialog open={open} fullWidth maxWidth="md">
            <DialogTitle disableTypography>
                <Typography variant='h4' color='textSecondary'>Close Ticket</Typography>
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={onCloseReset}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Ticket Id:</Typography></Grid>
                            <Grid item style={{ minWidth: "250px" }}><Typography variant="h5" color="textSecondary">{quantumId}</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Workorder:</Typography></Grid>
                            <Grid item style={{ minWidth: "250px" }}><Typography variant="h5" color="textSecondary">{workorder}</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Comment:</Typography></Grid>
                            <Grid item style={{ minWidth: "750px" }}><Grid item><TextField autoFocus variant="outlined" fullWidth multiline rows={5} rowsMax={8} value={comment} onChange={(event) => setComment(event.target.value)} /></Grid></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Button fullWidth variant="contained" color="primary" size="small" disabled={comment.length < 5} onClick={onTicketSubmit}><Typography variant="h6" color="textSecondary">Close</Typography></Button></Grid>
                            <Grid item style={{ minWidth: "150px" }}><Button fullWidth variant="contained" color="secondary" size="small" onClick={() => setComment("")}><Typography variant="h6" color="textSecondary">Clear</Typography></Button></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const ODSComment = ({ open, quantumId, workorder, onClose, onSubmit }) => {
    const classes = makeStyles((theme) => ({
        closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
    }))()
    const [comment, setComment] = React.useState("")

    const onCloseReset = () => {
        setComment("")
        onClose()
    }

    const onTicketSubmit = () => {
        onSubmit(comment)
        onCloseReset()
    }

    return (
        <Dialog open={open} fullWidth maxWidth="md">
            <DialogTitle disableTypography>
                <Typography variant='h4' color='textSecondary'>ODS Support Request</Typography>
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={onCloseReset}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Grid container direction='column' justify='flex-start' alignItems='flex-start' spacing={2}>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Ticket Id:</Typography></Grid>
                            <Grid item style={{ minWidth: "250px" }}><Typography variant="h5" color="textSecondary">{quantumId}</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Workorder:</Typography></Grid>
                            <Grid item style={{ minWidth: "250px" }}><Typography variant="h5" color="textSecondary">{workorder}</Typography></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Typography variant="h5" color="textSecondary">Comment:</Typography></Grid>
                            <Grid item style={{ minWidth: "750px" }}><Grid item><TextField autoFocus variant="outlined" fullWidth multiline rows={5} rowsMax={8} value={comment} onChange={(event) => setComment(event.target.value)} /></Grid></Grid>
                        </Grid>
                    </Grid>
                    <Grid item>
                        <Grid container direction='row' justify='flex-start' alignItems='flex-start' spacing={2}>
                            <Grid item style={{ minWidth: "150px" }}><Button fullWidth variant="contained" color="primary" size="small" disabled={comment.length < 5} onClick={onTicketSubmit}><Typography variant="h6" color="textSecondary">Send Request</Typography></Button></Grid>
                            <Grid item style={{ minWidth: "150px" }}><Button fullWidth variant="contained" color="secondary" size="small" onClick={() => setComment("")}><Typography variant="h6" color="textSecondary">Clear</Typography></Button></Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    )
}

const History = ({ controls }) => {
    const classes = makeStyles((theme) => ({
        cardroot: { maxHeight: "70vh", minHeight: "35vh", overflowY: "auto" },
        timelineContentCardRoot: { marginBottom: 20 },
        timelineOppositeContent: { flex: 0.1 },
        paper: {},
        closeButton: { position: 'absolute', right: theme.spacing(1), top: theme.spacing(1), color: red[900] },
        create: { backgroundColor: red[700] },
        assign: { backgroundColor: blue[900] },
        stepStart: { backgroundColor: teal[500] },
        stepEnd: { backgroundColor: teal[700] },
        fileUpload: { backgroundColor: orange[500] },
        close: { backgroundColor: purple['600'] },
        default: { backgroundColor: "#FFFFFF" },
        empty: {},
    }))()
    const [showFiles, setShowFiles] = React.useState({ id: 0, file: { fileId: 0, filename: null, type: null, imtid: null } })
    const [previewData, setPreviewData] = React.useState({ data: null, headers: {}, status: 0 })

    const timelineDotClassname = (action) => {
        switch (action) {
            case "CREATE_TICKET": return classes.create
            case "ASSIGN_USER": return classes.assign
            case "STEP_START": return classes.stepStart
            case "STEP_END": return classes.stepEnd
            case "CLOSE_TICKET": return classes.close
            case "FILE_UPLOAD": return classes.fileUpload
            default: return classes.default
        }
    }

    const getCardheaderProps = (title, comment) => {
        if (![undefined, null].includes(comment) && comment.length > 0) {
            comment = ReactHtmlParser(String(comment).replaceAll("\r\n", "\n").replaceAll("\n", "<br>"))
        } else {
            comment = null
        }
        var cardProps = {}
        if (![undefined, null].includes(title) && title.length > 0) {
            cardProps = { ...cardProps, title: title, titleTypographyProps: { variant: "h4", color: "textSecondary" } }
        }
        if (comment !== null) {
            cardProps = { ...cardProps, subheader: comment, subheaderTypographyProps: { variant: "h4", color: "textSecondary" } }
        }
        return cardProps
    }

    const onClose = () => {
        if (showFiles.file.fileId === 0) {
            controls.closeHistory()
            setShowFiles({ id: 0, file: { fileId: 0, filename: null, type: null, imtid: null } })
        } else {
            setShowFiles({ ...showFiles, file: { fileId: 0, filename: null, type: null, imtid: null } })
            setPreviewData({ data: null, headers: {}, status: 0 })
        }
    }

    const FileList = ({ files }) => {
        const _filenameext = (files) => {
            var filenameext = {}
            files.map((file) => { Object.entries(file).map(([id, name]) => { filenameext = { ...filenameext, [name]: { name: String(name).substring(0, String(name).lastIndexOf(".")).toUpperCase(), ext: String(name).substring(String(name).lastIndexOf(".") + 1).toUpperCase() } } }) })
            return filenameext
        }
        const filenameext = _filenameext(files)

        const onView = (id, name, imtid) => {
            setShowFiles({ ...showFiles, file: { fileId: id, filename: name, type: filenameext[name].ext, imtid: imtid } })
            DIYActions.RSSI.showFile({ fileId: id, imtid: imtid }).then((response) => {
                const reader = new FileReader()
                reader.onload = (event) => {
                    setPreviewData({ data: event.target.result, headers: response.headers, status: response.status })
                }
                reader.readAsDataURL(new Blob([response.data], { type: response.headers["content-type"] }))
            })
        }

        return (
            <TableContainer>
                <Table>
                    <TableBody>
                        {
                            files.map((file) => (
                                showFiles.file.fileId === file.id ? (
                                    <TableRow>
                                        <TableCell colSpan={3}>
                                            <TableContainer>
                                                <Table size="small">
                                                    <TableBody>
                                                        <TableRow>
                                                            <TableCell className={classes.tablenoborder}></TableCell>
                                                            <TableCell className={classes.tablenoborder} align="center" style={{ width: "50px" }}><IconButton color="secondary" size="small" onClick={onClose}><CancelPresentationIcon /></IconButton></TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell className={classes.tablenoborder} colSpan={3}>
                                                                <iframe src={previewData.data + "#toolbar=0&view=fitH"} style={{ width: '100%', height: '75vh', border: 'none', background: '#FFFFFF' }} />
                                                            </TableCell>
                                                        </TableRow>
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    <TableRow>
                                        <TableCell><Button fullWidth variant="text" color="primary" size="small"><Typography variant="h5" color="textSecondary">{file.filename}</Typography></Button></TableCell>
                                        <TableCell><Button fullWidth variant="contained" color="primary" size="small" disabled={!["PDF", "HTML", "TXT", "LOG", "PNG", "JPG", "JPEG"].includes(filenameext[file.filename].ext)} onClick={() => onView(file.id, file.filename, file.imtid)}><Typography variant="h6" color="textSecondary">VIEW</Typography></Button></TableCell>
                                        <TableCell><Button fullWidth variant="contained" color="primary" size="small" onClick={() => DIYActions.RSSI.download({ fileId: file.id, imtid: file.imtid }, file.filename)}><Typography variant="h6" color="textSecondary">DOWNLOAD</Typography></Button></TableCell>
                                    </TableRow>
                                )
                            ))
                        }
                    </TableBody>
                </Table>
            </TableContainer>
        )
    }

    return (
        <Dialog open={controls.open} fullWidth maxWidth="xl" onEntered={controls.getData}>
            <DialogTitle disableTypography>
                <Typography variant='h4' color='textSecondary'>History {'>'} {controls.quantumId} - {controls.workorder}</Typography>
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={onClose}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Card elevation={0} className={showFiles.file.fileId === 0 ? classes.cardroot : classes.empty}>
                    <Timeline align="left">
                        {
                            controls.records.map((record, index) => (
                                <TimelineItem key={index}>
                                    <TimelineOppositeContent className={classes.timelineOppositeContent}><Typography variant="h6" color="textSecondary">{record.Timestamp}</Typography></TimelineOppositeContent>
                                    <TimelineSeparator>
                                        <TimelineDot className={timelineDotClassname(record.Action)} />
                                        {record.id > 1 ? <TimelineConnector /> : null}
                                    </TimelineSeparator>
                                    <TimelineContent>
                                        <Card raised className={classes.timelineContentCardRoot}>
                                            <CardHeader
                                                {...getCardheaderProps(record.ActionData.title, record.ActionData.comment)}
                                                action={
                                                    ![undefined, null].includes(record.ActionData.files) && Object.keys(record.ActionData.files).length > 0 ? (
                                                        showFiles.id === record.id ? (
                                                            <Button variant="contained" color="secondary" size="small" onClick={() => setShowFiles({ id: 0, file: { fileId: 0, filename: null, type: null } })}><Typography variant="h5" color="textSecondary">Hide Files</Typography></Button>
                                                        ) : (
                                                            <Button variant="contained" color="primary" size="small" onClick={() => setShowFiles({ id: record.id, file: { fileId: 0, filename: null, type: null } })}><Typography variant="h5" color="textSecondary">Show Files</Typography></Button>
                                                        )
                                                    ) : null
                                                }
                                            />
                                            {
                                                showFiles.id === record.id ? (
                                                    <CardContent>
                                                        <Grid container direction="row" justify="space-between" alignItems="flex-start" spacing={1}>
                                                            <Grid item xs={12}><Paper className={classes.paper}><FileList files={record.ActionData.files} /></Paper></Grid>
                                                        </Grid>
                                                    </CardContent>
                                                ) : null
                                            }
                                        </Card>
                                    </TimelineContent>
                                </TimelineItem>
                            ))
                        }
                    </Timeline>
                </Card>
            </DialogContent>
        </Dialog>
    )
}

const FileUploadDialog = ({ mobileLayout = false, action = "EXTRA_FILE_UPLOAD", open = false, onClose = () => { }, data = {}, step = {}, onSubmit = () => { }, deeplinked = false }) => {
    const classes = useStyles()
    const [comment, setComment] = React.useState("")
    const [files, setFiles] = React.useState({})

    const fileDropAreaProps = {
        files: files,
        setFiles: setFiles,
        maxFiles: 50,
        dropAreaText: "Drag and drop your files here or Click here",
        typographyProps: { variant: "h3", color: "textSecondary" },
        style: {
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            height: "500px",
            borderWidth: "2px",
            borderRadius: "25px",
            borderColor: "#EEEEEE",
            borderStyle: "dashed",
            color: "#FFFFFF",
            transition: "border 0.3s ease-in-out 0s",
            justify: "center",
        },
        overrideStyles: true,
        validator: (file) => { },
    }

    const clear = () => {
        setComment("")
        setFiles({})
    }

    const onCloseReset = () => {
        onClose()
        clear()
    }

    const onSubmitClick = () => onSubmit(files, comment).then((response) => {
        if (response.data.status === "SUCCESS") {
            onCloseReset()
        }
    })

    const discardFile = (filename) => {
        var choosenFiles = { ...files }
        delete choosenFiles[filename]
        setFiles(choosenFiles)
    }

    return (
        <Dialog open={open} fullWidth maxWidth="xl">
            <DialogTitle disableTypography>
                <Typography variant='h4' color='textSecondary'>File Upload</Typography>
                <Tooltip title='Close'><IconButton aria-label="close" className={classes.closeButton} onClick={onCloseReset}><CloseIcon /></IconButton></Tooltip>
                <Divider style={{ backgroundColor: "#FFFFFF", marginTop: '5px', marginBottom: '5px' }} />
            </DialogTitle>
            <DialogContent>
                <Grid container direction="row" justify="space-between" alignItems="flex-start" spacing={1}>
                    {Object.keys(files).length < 10 ? <Grid item xs={6}><FileDropArea {...fileDropAreaProps} /></Grid> : null}
                    <Grid item xs={Object.keys(files).length < 10 ? 6 : 12}>
                        <Grid container direction="column" justify="flex-start" alignItems="stretch" spacing={1}>
                            <Grid item><TextField fullWidth multiline placeholder="Comments..." rows={10} rowsMax={10} variant="outlined" size="small" color="primary" value={comment} onChange={(event) => setComment(event.target.value)} /></Grid>
                            <Grid item><Typography variant="h4" color="textSecondary" align="left">Selected Files: {Object.keys(files).length} of 10</Typography></Grid>
                            {Object.keys(files).length > 10 ? <Grid item><Typography variant="h4" color="secondary" align="left">Files selected more than the limit</Typography></Grid> : null}
                            <Grid item>
                                <List dense={true} style={{ maxHeight: "200px", overflowX: "auto" }}>
                                    {
                                        Object.entries(files).map(([filename, file], index) => (
                                            <ListItem className={classes.hover} key={filename + "+" + String(index)}>
                                                <ListItemAvatar><Avatar className={classes.fileIcon} src={Icons.file(files[filename].file.filetype)} alt={files[filename].filetype + " - " + filename} /></ListItemAvatar>
                                                <ListItemText><Typography variant="h6" color="textSecondary">{filename}</Typography></ListItemText>
                                                <ListItemSecondaryAction><Grid item><IconButton aria-label="close" color="secondary" onClick={() => discardFile(filename)}><CloseIcon /></IconButton></Grid></ListItemSecondaryAction>
                                            </ListItem>
                                        ))
                                    }
                                </List>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions><Button variant="contained" color="primary" size="small" style={{ width: "250px" }} disabled={!(comment.length !== 0 && Object.keys(files).length <= 10)} onClick={onSubmitClick}><Typography variant="h6" color="textSecondary">Submit</Typography></Button></DialogActions>
        </Dialog>
    )
}

const RSSITicketsTable = ({ tickets, refresh = () => { }, colSpan = 9, isMobile = false, classnames = {}, selectedTicketId = null, deeplinked = false }) => {
    const classes = useStyles()
    const [ticketId, setTicketId] = React.useState(selectedTicketId)
    const [uploadDialog, setUploadDialog] = React.useState({ open: false, action: null, stepId: null, step: {}, ticket: {} })
    const [history, setHistory] = React.useState({ open: false, quantumId: null, workorder: null, records: [] })
    const [odsRequestDialog, setODSRequestDialog] = React.useState({ open: false, quantumId: null, workorder: null })
    const [closeCommentDialog, setCloseCommentDialog] = React.useState({ open: false, quantumId: null, workorder: null })

    const onAction = (quantumId, workorder, action, stepNumber, files, comment) => {
        var payload = new FormData()
        payload.append("quantumId", quantumId)
        payload.append("workorder", workorder)
        payload.append("action", action)
        payload.append("stepNumber", stepNumber)
        payload.append("comment", comment)
        Object.entries(files).map(([filename, file]) => payload.append(filename, file.file))
        return DIYActions.RSSI.onAction(payload).then((response) => {
            if (response.data.status === "SUCCESS") {
                refresh()
            }
            return response
        }).catch(console.error)
    }

    const sectionComplete = (sectionId, actionCode, step) => {
        console.log(sectionId, actionCode, step)
        var checked = false
        if (data.Steps[sectionId].Checklist) {
            var itemsCompleted = true
            Object.keys(data.Steps[sectionId].ChecklistItems).map((item) => {
                var step = data.Steps[sectionId].ChecklistItems[item]
                if (itemsCompleted) {
                    itemsCompleted = step.StepCompleted
                }
            })
            checked = itemsCompleted
        } else {
            checked = true
        }
        if (checked) {
            setDialog({ open: true, action: "SECTION_COMPLETE", stepId: sectionId, actionCode: actionCode, step: step })
        }
    }

    const markChecklistItem = (event, ChecklistItemsId, ChecklistItem) => {
        event.stopPropagation()
        if (!ChecklistItem.StepCompleted) {
            DIYActions.RSSI.markChecklistItem({ quantumId: data.QuantumId, workorder: data.RSSIWorkorder, sectionId: selectedSection, checklistitemid: ChecklistItemsId }).then((response) => {
                if (response.data.status === "SUCCESS") {
                    if (![undefined, null].includes(response.data.ticket)) {
                        var newData = [...alldata.data.data]
                        newData[index] = response.data.ticket
                        // setData({status: data.status, data: {count: data.data.count, data: newData}})
                        setDataUpdate({ status: alldata.status, data: { count: alldata.data.count, data: newData } })
                    }
                }
            }).catch(console.error)
        }
    }

    const stepControls = {
        sectionComplete: (sectionId, actionCode, step) => console.info(sectionId, actionCode, step),
        markChecklistItem: (event, ChecklistItemsId, ChecklistItem) => console.info(event, ChecklistItemsId, ChecklistItem),
    }

    const historyControls = {
        ...history,
        showHistory: (quantumId, workorder) => setHistory({ open: true, quantumId: quantumId, workorder: workorder, records: [] }),
        closeHistory: () => setHistory({ open: false, quantumId: null, workorder: null, records: [] }),
        getData: () => DIYActions.RSSI.getTicketHistory(history.quantumId, history.workorder, (data) => setHistory((current) => { return { ...current, records: data } }))
    }

    const odsDialogControls = {
        openDialog: (quantumId, workorder) => setODSRequestDialog({ open: true, quantumId, workorder }),
        closeDialog: () => setODSRequestDialog({ open: false, quantumId: null, workorder: null }),
        onClose: (comment) => onAction(odsRequestDialog.quantumId, odsRequestDialog.workorder, "ODS_SUPPORT_REQUESTED", null, {}, comment)
    }

    const closeDialogControls = {
        openDialog: (quantumId, workorder) => setCloseCommentDialog({ open: true, quantumId, workorder }),
        closeDialog: () => setCloseCommentDialog({ open: false, quantumId: null, workorder: null }),
        onClose: (comment) => onAction(closeCommentDialog.quantumId, closeCommentDialog.workorder, "TICKET_CLOSE", null, {}, comment)
    }

    const checkDisableClose = (steps) => {
        // closeable is true to enable the close button and
        // false to disable it. closeable defines if close button
        // is enable or not and we want it to be false.
        var closeable = true
        Object.entries(steps).map(([stepId, step]) => {
            if (!step.Completed) {
                closeable = false
                return
            }
        })
        return closeable === false
    }

    return (
        <React.Fragment>
            <TableRow classes={{ root: classes.tableRow }}>
                <TableCell className={classnames.tablecell} colSpan={colSpan}>
                    <TableContainer>
                        <Table size="small">
                            <TableHead>
                                <TableRow>
                                    {selectedTicketId === null ? <TableCell className={classnames.tablecell} variant="head" size="small" align="center" style={{ width: "20px" }} /> : null}
                                    <TableCell className={classnames.tablecell} variant="head" size="small" align="center"><Typography variant="h6" color="textSecondary">QuantumId</Typography></TableCell>
                                    <TableCell className={classnames.tablecell} variant="head" size="small" align="center"><Typography variant="h6" color="textSecondary">RSSIWorkorder</Typography></TableCell>
                                    <TableCell className={classnames.tablecell} variant="head" size="small" align="center"><Typography variant="h6" color="textSecondary">Status</Typography></TableCell>
                                    <TableCell className={classnames.tablecell} variant="head" size="small" align="center"><Typography variant="h6" color="textSecondary">Updated At</Typography></TableCell>
                                    <TableCell className={classnames.tablecell} variant="head" size="small" align="center" />
                                    <TableCell className={classnames.tablecell} variant="head" size="small" align="center" />
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {
                                    tickets.map((ticket) => (
                                        <React.Fragment>
                                            <TableRow>
                                                {selectedTicketId === null ? ticket.TargetUser.Name !== "UNASSIGNED" ? <TableCell className={classnames.tablecell} variant="body" size="small" align="left">{<IconButton size="small" onClick={ticketId === ticket.id ? () => setTicketId(null) : () => setTicketId(ticket.id)}>{ticketId === ticket.id ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}</IconButton>}</TableCell> : null : null}
                                                <TableCell className={classnames.tablecell} variant="body" size="small" align="center"><Typography variant="h6" color="textSecondary">{ticket.QuantumId}</Typography></TableCell>
                                                <TableCell className={classnames.tablecell} variant="body" size="small" align="center"><Typography variant="h6" color="textSecondary">{ticket.RSSIWorkorder}</Typography></TableCell>
                                                <TableCell className={classnames.tablecell} variant="body" size="small" align="center"><Typography variant="h6" color="textSecondary">{ticket.Status}</Typography></TableCell>
                                                <TableCell className={classnames.tablecell} variant="body" size="small" align="center"><Typography variant="h6" color="textSecondary">{ticket.UpdateTimestamp}</Typography></TableCell>
                                                <TableCell className={classnames.tablecell} variant="body" size="small" align="center" style={{ width: "100px" }}><Button fullWidth variant="contained" color="primary" size="small" onClick={() => historyControls.showHistory(ticket.QuantumId, ticket.RSSIWorkorder)}><Typography variant="h6" color="textSecondary">History</Typography></Button></TableCell>
                                                <TableCell className={classnames.tablecell} variant="body" size="small" align="center" style={{ width: "100px" }}>{ticket.Status !== "CLOSED" ? <Button fullWidth variant="contained" color="primary" size="small" disabled={checkDisableClose(ticket.Steps)} onClick={() => closeDialogControls.openDialog(ticket.QuantumId, ticket.RSSIWorkorder)}><Typography variant="h6" color="textSecondary">Close</Typography></Button> : null}</TableCell>
                                            </TableRow>
                                            {ticket.id === ticketId ? <TableRow classes={{ root: classes.tableRow }}>{selectedTicketId === null ? <TableCell className={classnames.tablecell} /> : null}<TableCell className={classnames.tablecell} colSpan={8}><RSSITicketSteps ticket={ticket} stepControls={stepControls} classnames={classnames} /></TableCell></TableRow> : null}
                                        </React.Fragment>
                                    ))
                                }
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TableCell>
            </TableRow>
            <History controls={historyControls} />
            <FileUploadDialog open={uploadDialog.open} action={uploadDialog.action} data={uploadDialog.ticket} step={uploadDialog.step} onSubmit={stepControls.onSubmit} onClose={() => setUploadDialog({ open: false, action: null, stepId: {}, step: {} })} />
            <ODSComment open={odsRequestDialog.open} quantumId={odsRequestDialog.quantumId} workorder={odsRequestDialog.workorder} onClose={odsDialogControls.closeDialog} onSubmit={odsDialogControls.onClose} />
            <CloseComment open={closeCommentDialog.open} quantumId={closeCommentDialog.quantumId} workorder={closeCommentDialog.workorder} onClose={closeDialogControls.closeDialog} onSubmit={closeDialogControls.onClose} />
        </React.Fragment>
    )
}

export default RSSITicketsTable
